<template>
  <div>
    <CRow class="mt-4 ml-2 mr-2 mb-3">
      <CCol sm="3 d-flex">
        <div style="border-radius: 8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
          <div class="mb-3">
            <div class="card-title mb-1">Cuti Hari Ini</div>
            <div class="card-subtitle">Data pegawai yang cuti hari ini</div>
          </div>
          <div class="row no-gutters">
            <div class="col-md-6">
              <span style="font-size: 28px; color: rgba(16, 16, 16, 1); font-weight: 600" class="text-left">{{ totalCuti }}</span>
              <span style="font-size: 12px; color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
            </div>
            <div class="col-md-6 pt-1">
              <div class="card-emblem">
                <img :src="totalKaryawanOvertimeIcon" width="20px" height="20px" />
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="3 d-flex">
        <div style="border-radius: 8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
          <div class="mb-3">
            <div class="card-title mb-1">Rencana Cuti</div>
            <div class="card-subtitle">Data pegawai yang akan cuti</div>
          </div>
          <div class="row no-gutters">
            <div class="col-md-6">
              <span style="font-size: 28px; color: rgba(16, 16, 16, 1); font-weight: 600" class="text-left">{{ totalRencana }}</span>
              <span style="font-size: 12px; color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
            </div>
            <div class="col-md-6 pt-1">
              <div class="card-emblem">
                <img :src="totalJamOvertimeIcon" width="20px" height="20px" />
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="3 d-flex">
        <div style="border-radius: 8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
          <div class="mb-3">
            <div class="card-title mb-1">Cuti Tak Terencana</div>
            <div class="card-subtitle">Data pegawai yang cuti hari ini</div>
          </div>
          <div class="row no-gutters">
            <div class="col-md-6">
              <span style="font-size: 28px; color: rgba(16, 16, 16, 1); font-weight: 600" class="text-left">{{ totalTakTerencana }}</span>
              <span style="font-size: 12px; color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
            </div>
            <div class="col-md-6 pt-1">
              <div class="card-emblem">
                <img :src="pendingRequestIcon" width="20px" height="20px" />
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol sm="3 d-flex">
        <div style="border-radius: 8px" class="card p-0 mb-1 bg-white w-100 px-3 py-3">
          <div class="mb-3">
            <div class="card-title mb-1">Menunggu Keputusan</div>
            <div class="card-subtitle">Data pegawai menunggu approval</div>
          </div>
          <div class="row no-gutters">
            <div class="col-md-6">
              <span style="font-size: 28px; color: rgba(16, 16, 16, 1); font-weight: 600" class="text-left">{{ totalMenunggu }}</span>
              <span style="font-size: 12px; color: rgba(154, 154, 154, 1)" class="text-left"> Pegawai</span>
            </div>
            <div class="col-md-6 pt-1">
              <div class="card-emblem">
                <img :src="ditolakIcon" width="20px" height="20px" />
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
    <div class="search-area">
      <CAlert v-if="success == true" :show.sync="currentAlertCounter" closeButton style="background-color: rgba(48, 107, 221, 1); border-radius: 0; text-align: center; color: white">
        {{ alertMess }}
      </CAlert>
      <CAlert v-else :show.sync="currentAlertCounter" closeButton style="background-color: red; border-radius: 0; text-align: center; color: white">
        {{ alertMess }}
      </CAlert>
      <CRow class="no-gutters">
        <CCol sm="2" style="padding-right: 4px">
          <div class="autocomplete">
            <input
              type="text"
              class="form-control"
              @click="toggleVisiblePegawai()"
              @blur="toggleCloseVisiblePegawai()"
              v-model="queryPegawai"
              v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
              @keydown.up="upPegawai"
              @keydown.down="downPegawai"
              @keydown.enter="selectItemPegawai"
              placeholder="Pilih Pegawai" />
            <div class="popovers" v-show="visiblePegawai">
              <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                <ul>
                  <li v-for="(match, index) in matchesPegawai" :key="index" :class="{ selected: selectedPegawai == index }" @click="itemClickedPegawai(index)" v-text="match['text']"></li>
                </ul>
              </div>
              <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">Data Tidak Ditemukan</div>
              <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">Start Typing...</div>
            </div>
          </div>
        </CCol>
        <CCol sm="2" style="padding-right: 4px; padding-left: 4px">
          <model-select style="background-color: rgba(249, 250, 252, 1)" :options="dataStatus" class="form-control" v-model="selectedStatus" placeholder="Pilih Status"></model-select>
        </CCol>
        <CCol sm="2" style="padding-right: 4px; padding-left: 4px">
          <model-select style="background-color: rgba(249, 250, 252, 1)" :options="dataType" class="form-control" v-model="selectedType" placeholder="Type"></model-select>
        </CCol>
        <CCol sm="2" style="padding-right: 4px; padding-left: 4px">
          <model-select style="background-color: rgba(249, 250, 252, 1)" :options="dataTipePegawai" class="form-control" v-model="tipePegawai" placeholder="Type"></model-select>
        </CCol>
        <CCol sm="1" style="padding-right: 4px; padding-left: 4px">
          <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Mulai" v-model="dateStart" class="form-control" />
        </CCol>
        <CCol sm="1" style="padding-right: 4px; padding-left: 4px">
          <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Selesai" v-model="dateEnd" class="form-control" />
        </CCol>
        <CCol sm="2" style="padding-right: 4px; padding-left: 6px">
          <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
        </CCol>
      </CRow>
    </div>
    <div class="sticky1">
      <CRow class="no-gutters">
        <CCol sm="4" style="float: left">
          <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor: pointer; float: left" />
          <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float: left; cursor: pointer" :src="downloadIcon" title="export to excel" width="20px" height="20px" />
          <img class="mr-4 mt-1" style="float: left" :src="moreIcon" width="20px" height="20px" />
        </CCol>
        <CCol sm="2" v-if="roleAdmin != 'Y' || roleAdmin == ''"></CCol>
        <CCol sm="6">
          <span style="float: right">
            <CButton v-if="page == 1" disabled style="cursor: default" class="rounded"><font-awesome-icon :icon="{ prefix: 'fas', iconName: 'chevron-left' }" /></CButton>
            <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{ prefix: 'fas', iconName: 'chevron-left' }" /></CButton>
            <CButton v-if="page == totalPage" style="cursor: default" disabled class="rounded"><font-awesome-icon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" /></CButton>
            <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" /></CButton>
          </span>
          <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1); width: 50px; float: right" v-model.number="page" class="text-center rounded p-1" type="text" />
          <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1); width: 50px; float: right" v-model="page" class="text-center rounded p-1" type="text" />
          <span class="mr-3 mt-1" style="color: rgba(154, 154, 154, 1); float: right"
            ><span style="color: rgba(16, 16, 16, 1)">{{ firstPage }} - {{ lastPage }}</span> of {{ totalRow }}</span
          >
        </CCol>
        <CCol v-if="roleAdmin == 'Y'" style="padding-left: 8px" sm="2">
          <CButton @click="modalAdd = true" type="button" class="btn btn-add">Tambah</CButton>
        </CCol>
      </CRow>
    </div>
    <Tables @sort="sorting" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    <CModal size="lg" :centered="true" color="white" :show.sync="modalAdd" :closeOnBackdrop="false">
      <template #header-wrapper>
        <div class="headers-modal">
          <CRow>
            <CCol sm="10">
              <div>Tambah Izin Cuti Dan Lainnya</div>
            </CCol>
            <CCol sm="2" class="text-right">
              <img :src="closeIcon" @click="modalAdd = false" style="cursor: pointer" width="20px" height="20px" />
            </CCol>
          </CRow>
        </div>
      </template>
      <template #body-wrapper>
        <div style="padding-bottom: 40px; padding-right: 20px; padding-left: 20px">
          <CRow class="mt-2">
            <CCol sm="6">
              <label>Nama Pegawai</label>
              <div class="autocomplete">
                <input
                  type="text"
                  class="form-control"
                  @click="toggleVisibleAddPegawai()"
                  @blur="toggleCloseVisibleAddPegawai()"
                  v-model="queryAddPegawai"
                  v-text="selectedItemAddPegawai ? selectedItemAddPegawai['text'] : ''"
                  @keydown.up="upAddPegawai"
                  @keydown.down="downAddPegawai"
                  @keydown.enter="selectItemAddPegawai"
                  placeholder="Pilih Pegawai" />
                <div class="popovers" v-show="visibleAddPegawai">
                  <div class="options" v-if="matchesAddPegawai.length != 0 && queryAddPegawai.length != 0" ref="optionsList">
                    <ul>
                      <li v-for="(match, index) in matchesAddPegawai" :key="index" :class="{ selected: selectedAddPegawai == index }" @click="itemClickedAddPegawai(index)" v-text="match['text']"></li>
                    </ul>
                  </div>
                  <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length != 0">Data Tidak Ditemukan</div>
                  <div class="options" v-if="matchesAddPegawai.length == 0 && queryAddPegawai.length == 0">Start Typing...</div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <label>Jenis Izin</label>
              <model-select style="background-color: rgba(249, 250, 252, 1)" :options="dataAddTipe" class="form-control" v-model="addTipe" placeholder="Pilih Jenis"></model-select>
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label>Tanggal Mulai</label>
              <input class="form-control" type="date" v-model="addTanggalMulai" />
            </CCol>
            <CCol sm="6">
              <label>Tanggal Selesai</label>
              <input :disabled="addTanggalMulai == ''" :min="addTanggalMulai" class="form-control" type="date" v-model="addTanggalSelesai" />
            </CCol>
          </CRow>
          <CRow class="mt-3">
            <CCol sm="6">
              <label>Keterangan</label>
              <input class="form-control" placeholder="Masukan Keterangan/Komentar" v-model="addKeterangan" />
            </CCol>
            <CCol sm="6">
              <label>Bukti File</label>
              <model-select style="background-color: rgba(249, 250, 252, 1)" :options="dataAddBukti" class="form-control" v-model="addBukti" placeholder="Pilih Bukti File"></model-select>
            </CCol>
          </CRow>
          <CRow v-if="addBukti.value == '1'" class="mt-3">
            <CCol sm="6">
              <label>Foto/Image File</label>
              <div v-if="urlImage == '' || urlImage == 'null'">
                <input v-on:change="onFileChange" style="position: absolute; opacity: 0; z-index: 1; cursor: pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                <div class="cards-image">+</div>
              </div>
              <div v-else>
                <img :src="urlImage" width="56" height="56" />
                <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
              </div>
            </CCol>
          </CRow>
          <CRow v-if="addBukti.value == '2'" class="mt-3">
            <CCol sm="6">
              <label>PDF File</label>
              <div>
                <CButton v-if="file == '' && file == null" type="button" onclick="document.getElementById('inputFile').click()" class="btn btn-cancel">Pilih Dokumen</CButton>
                <input type="file" accept=".pdf, .PDF" @change="loadFile()" style="display: none" id="inputFile" class="hide" />
              </div>
              <!--  -->
              <p v-if="file != ''" class="font-weight-bold">
                <span class="mr-3">{{ fileName }}</span>
              </p>
            </CCol>
          </CRow>
          <CRow class="mt-4" v-if="errAlert != ''">
            <CCol sm="6"></CCol>
            <CCol sm="6">
              <span class="text-danger">{{ errAlert }}</span>
            </CCol>
          </CRow>
          <CRow class="mt-5">
            <CCol sm="10"></CCol>
            <CCol sm="2">
              <CButton style="width: 100% !important" @click="addData()" class="btn-cancel">Simpan</CButton>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #footer-wrapper><span></span></template>
    </CModal>
  </div>
</template>

<script>
import Tables from '../component/tableCuti';
import { ModelSelect } from 'vue-search-select';
import { DataApi, DataApiUpload } from '../service/DataApi';

export default {
  components: {
    Tables,
    ModelSelect,
  },
  data() {
    return {
      success: true,
      itemHeight: 39,
      // data search pegawai
      dataPegawai: [],
      titlePegawai: 'Pilih Pegawai',
      selectedItemPegawai: null,
      selectedPegawai: 0,
      queryPegawai: '',
      visiblePegawai: false,

      totalKaryawanOvertimeIcon: require('../assets/menu/icon_overtime_2.svg'),
      totalJamOvertimeIcon: require('../assets/menu/icon_overtime_3.svg'),
      pendingRequestIcon: require('../assets/menu/icon_overtime_4.svg'),
      ditolakIcon: require('../assets/menu/icon_overtime_1.svg'),
      refreshIcon: require('../assets/menu/icon_refresh.svg'),
      downloadIcon: require('../assets/menu/icon_download_excel.svg'),
      closeIcon: require('../assets/menu/icon_close.svg'),
      moreIcon: require('../assets/menu/icon_more.svg'),

      dataTh: ['Nama', 'Tipe Cuti', 'Tanggal Mulai', 'Tanggal Selesai', 'Lama Cuti', 'Approve By', 'Status'],
      dataTd: ['nama', 'keterangan', 'tanggalMulai', 'tanggalSelesai', 'lamaCuti', 'namaAtasan', 'status'],
      styleTable: ['150px', '120px', '130px', '130px', '120px', '150px', '120px'],
      classReload: 'reloadOff',

      loading: false,
      alertMess: '',
      currentAlertCounter: 0,

      totalCuti: 0,
      totalRencana: 0,
      totalTakTerencana: 0,
      totalMenunggu: 0,

      // paging
      page: 1,
      size: 20,
      totalRow: 0,
      totalPage: 1,
      firstPage: 0,
      lastPage: 0,

      // filter
      dateStart: '',
      dateEnd: '',
      selectedType: {
        text: '',
        value: '',
      },
      selectedStatus: {
        text: '',
        value: '',
      },
      tipePegawai: {
        value: '',
        text: '',
      },
      dataTipePegawai: [],

      // datas
      datas: [],
      dataStatus: [],
      dataType: [],

      // error
      errorMessage: '',

      roleAdmin: '',
      lvl: '',
      organisasi: '',
      modalAdd: false,

      dataAddPegawai: [],
      titleAddPegawai: 'Pilih Pegawai',
      selectedItemAddPegawai: null,
      selectedAddPegawai: 0,
      queryAddPegawai: '',
      visibleAddPegawai: false,
      idAddPegawai: '',

      dataAddTipe: [],
      addTipe: {
        value: '',
        text: '',
      },
      addTanggalMulai: '',
      addTanggalSelesai: '',
      addKeterangan: '',
      dataAddBukti: [],
      addBukti: {
        value: '',
        text: '',
      },
      //image
      urlImage: '',
      showImage: '',
      urlPath: '',

      //pdf
      file: '',
      fileName: '',
      fileSize: '',
      urlFile: '',
      tempFile: [],
      errAlert: '',
      flagSearch: false,
    };
  },
  watch: {
    page() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    queryPegawai() {
      this.flagSearch = true;
      this.getDataPegawai();
    },
    queryAddPegawai() {
      this.getDataAddPegawai();
      if (this.queryAddPegawai == '') {
        this.idAddPegawai = '';
      }
    },
    dateStart() {
      this.flagSearch = true;
    },
    dateEnd() {
      this.flagSearch = true;
    },
    selectedType() {
      this.flagSearch = true;
    },
    selectedStatus() {
      this.flagSearch = true;
    },
    modalAdd() {
      if (this.modalAdd == false) {
        this.dataAddPegawai = [];
        this.queryAddPegawai = '';
        this.idAddPegawai = '';
        this.dataAddTipe = [];
        this.addTipe.value = '';
        this.addTipe.text = '';
        this.addTanggalMulai = '';
        this.addTanggalSelesai = '';
        this.addKeterangan = '';
        this.addBukti.value = '';
        this.addBukti.text = '';
        this.dataAddBukti = [];
        this.urlImage = '';
        this.showImage = '';
        this.urlPath = '';
        this.file = '';
        this.fileName = '';
        this.fileSize = '';
        this.urlFile = '';
        this.tempFile = [];
        this.errAlert = '';
        this.getDataAddTipe();
        this.getDataAddBukti();
      }
    },
    tipePegawai() {
      this.flagSearch = true;
    },
  },
  methods: {
    /**
     * ADD CUTI
     */
    getDataAddPegawai() {
      let nama = this.queryAddPegawai;
      let payload = {
        bidang: '',
        jabatan: '',
        limit: 10,
        nama: nama,
        pageIn: 1,
        pegawaiId: '',
        tipePegawai: '',
      };
      DataApi.post('pegawai/get', payload).then((res) => {
        this.dataAddPegawai = [];
        let response = res.data;
        let tempData = response.data.data;
        var i = 0;
        for (i = 0; i < tempData.length; i++) {
          let onPush = {
            value: tempData[i].idPegawai,
            text: tempData[i].nama + ' - ' + tempData[i].nik,
          };
          this.dataAddPegawai.push(onPush);
        }
      });
    },
    toggleVisibleAddPegawai() {
      this.visibleAddPegawai = true;
    },
    hideAddPegawai() {
      this.visibleAddPegawai = false;
    },
    toggleCloseVisibleAddPegawai() {
      setTimeout(this.hideAddPegawai, 1000);
    },
    itemClickedAddPegawai(index) {
      this.selectedAddPegawai = index;
      this.selectItemAddPegawai();
    },
    selectItemAddPegawai() {
      if (!this.matchesAddPegawai.length) {
        return;
      }
      this.selectedItemAddPegawai = this.matchesAddPegawai[this.selectedAddPegawai];
      this.visibleAddPegawai = false;
      this.queryAddPegawai = this.selectedItemAddPegawai.text;
      this.idAddPegawai = this.selectedItemAddPegawai.value;
      if (this.shouldReset) {
        this.queryAddPegawai = '';
        this.selectedAddPegawai = 0;
      }
    },
    upAddPegawai() {
      if (this.selectedAddPegawai == 0) {
        return;
      }
      this.selectedAddPegawai -= 1;
      this.scrollToItemAddPegawai();
    },
    downAddPegawai() {
      if (this.selectedAddPegawai >= this.matchesAddPegawai.length - 1) {
        return;
      }
      this.selectedAddPegawai += 1;
      this.scrollToItemAddPegawai();
    },
    scrollToItemAddPegawai() {
      this.$refs.optionsList.scrollTop = this.selectedAddPegawai * this.itemHeight;
    },

    getDataAddTipe() {
      let payload = {
        kelompok: '',
        keterangan: '',
        kode: '',
        limit: 999,
        pageIn: 1,
      };
      DataApi.post('absensi/backoffice/tidak_masuk_lihat', payload).then((res) => {
        this.dataAddTipe = [];
        let response = res.data.data.data;
        var i = 0;
        for (i = 0; i < response.length; i++) {
          let pushs = {
            value: response[i].kode,
            text: response[i].keterangan,
          };
          this.dataAddTipe.push(pushs);
        }
      });
    },

    getDataAddBukti() {
      this.dataAddBukti = [
        { value: '1', text: 'Image/Foto' },
        { value: '2', text: 'PDF' },
      ];
    },

    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.showImage = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.urlImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    saveImage() {
      if (this.urlImage.split(':')[0] == 'data' && this.urlImage != '') {
        let imageData = this.showImage;
        let idPegawaiData = 0;
        let inOutData = '1';
        let kodePerusahaanData = this.organisasi;
        let tanggalData = new Date();
        let lvlData = this.lvl;

        const fd = new FormData();
        fd.append('file', imageData);
        fd.append('idPegawai', idPegawaiData);
        fd.append('inOut', inOutData);
        fd.append('kodePerusahaan', kodePerusahaanData);
        fd.append('tanggal', tanggalData);
        fd.append('lvl', lvlData);

        DataApiUpload.post('upload/file', fd).then((res) => {
          let response = res.data;
          if (response.success == true) {
            this.urlPath = response.data.urlPath;
            this.submitSave('1');
          } else {
            alert('Upload Photo Failed !');
            this.loading = false;
          }
        });
      } else if (this.urlImage == '') {
        this.urlPath = '';
        this.submitSave('1');
      } else {
        this.urlPath = this.urlImage;
        this.submitSave('1');
      }
    },
    removeImage() {
      this.showImage = '';
      this.urlImage = '';
      this.urlPath = '';
    },

    loadFile(e) {
      let files = document.getElementById('inputFile').files[0];
      this.file = files;
      this.fileName = files.name;
      this.fileSize = files.size;
    },
    uploadFile() {
      if (parseInt(this.fileSize) > 2000000) {
        alert('Maaf, Maksimal lampiran 2MB');
        setTimeout(this.clearFile, 200);
      } else {
        this.prosessUpload();
      }
    },
    prosessUpload() {
      if (this.file != '') {
        let imageData = this.file;

        const fd = new FormData();
        fd.append('file', imageData);

        DataApiUpload.post('upload', fd).then((res) => {
          let response = res.data;
          if (response.success == true) {
            this.urlFile = response.data.path;
            this.submitSave('2');
          } else {
            alert('Upload File Failed !');
          }
        });
      } else if (this.file == '') {
        this.urlFile = '';
      }
    },
    clearFile() {
      this.deskripsi = '';
      this.fileName = '';
      this.fileSize = '';
      this.urlFile = '';
      this.file = '';
    },

    addData() {
      if (this.addBukti.value == '') {
        this.errAlert = '*Harap melengkapi data terlebih dahulu';
      } else {
        if (this.addBukti.value == '1') {
          if (this.idAddPegawai != '' && this.addTipe.value != '' && this.addTanggalMulai != '' && this.addTanggalSelesai != '' && this.addKeterangan != '' && this.urlImage != '') {
            this.saveImage();
            this.$store.state.loadingScreen = true;
            this.errAlert = '';
          } else {
            this.errAlert = '*Harap melengkapi data terlebih dahulu';
          }
        } else if (this.addBukti.value == '2') {
          if (this.idAddPegawai != '' && this.addTipe.value != '' && this.addTanggalMulai != '' && this.addTanggalSelesai != '' && this.addKeterangan != '' && this.file != '') {
            this.uploadFile();
            this.$store.state.loadingScreen = true;
            this.errAlert = '';
          } else {
            this.errAlert = '*Harap melengkapi data terlebih dahulu';
          }
        }
      }
    },

    submitSave(num) {
      let file = '';
      let file2 = '';
      if (num == '1') {
        file = this.urlPath;
        file2 = '';
      } else if (num == '2') {
        file = '';
        file2 = this.urlFile;
      }
      let payload = {
        idPegawai: this.idAddPegawai,
        keteranganApprove: this.addKeterangan,
        kodeTidakMasuk: this.addTipe.value,
        tanggalMulai: this.addTanggalMulai,
        tanggalSelesai: this.addTanggalSelesai,
        tipe: 'C',
        unix: '',
        urlFile: file2,
        urlFoto: file,
      };
      DataApi.post('cuti/simpan', payload).then((res) => {
        let response = res.data;
        if (response.success == true) {
          if (response.data.Data1 == 'Y') {
            this.success = true;
          } else {
            this.success = false;
          }
          this.alertMess = response.data.Data2;
        } else {
          this.alertMess = response.message;
          this.success = false;
        }
        this.$store.state.loadingScreen = false;
        this.getDataRekap();
        this.getData();
        this.modalAdd = false;
        this.currentAlertCounter = 7;
      });
    },
    /**
     * END ADD CUTI
     */

    /**
     * SEARCH PEGAWAI
     */
    getDataAdmin() {
      this.$store.state.loadingScreen = true;
      DataApi.get('pegawai/role/cek').then((response) => {
        let res = response.data;
        if (res.success == true) {
          this.roleAdmin = res.data.admin;
          this.lvl = res.data.lvl;
          this.organisasi = res.data.organisasi;
        }
        this.$store.state.loadingScreen = false;
        this.getDataType();
        this.getDataPegawai();
        this.getDataStatus();
        this.getDataRekap();
      });
    },
    getDataPegawai() {
      let payload = {
        bidang: '',
        jabatan: '',
        limit: 10,
        nama: this.queryPegawai,
        pageIn: 1,
        pegawaiId: '',
        tipePegawai: '',
      };
      DataApi.post('pegawai/get', payload).then((res) => {
        this.dataPegawai = [];
        let response = res.data;
        let tempData = response.data.data;
        var i = 0;
        for (i = 0; i < tempData.length; i++) {
          let onPush = {
            value: tempData[i].nik,
            text: tempData[i].nama + ' - ' + tempData[i].nik,
          };
          this.dataPegawai.push(onPush);
        }
      });
    },
    toggleVisiblePegawai() {
      this.visiblePegawai = true;
    },
    hidePegawai() {
      this.visiblePegawai = false;
    },
    toggleCloseVisiblePegawai() {
      setTimeout(this.hidePegawai, 1000);
    },
    itemClickedPegawai(index) {
      this.selectedPegawai = index;
      this.selectItemPegawai();
    },
    selectItemPegawai() {
      if (!this.matchesPegawai.length) {
        return;
      }
      this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
      this.visiblePegawai = false;
      this.queryPegawai = this.selectedItemPegawai.text;
      if (this.shouldReset) {
        this.queryPegawai = '';
        this.selectedPegawai = 0;
      }
    },
    upPegawai() {
      if (this.selectedPegawai == 0) {
        return;
      }
      this.selectedPegawai -= 1;
      this.scrollToItemPegawai();
    },
    downPegawai() {
      if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
        return;
      }
      this.selectedPegawai += 1;
      this.scrollToItemPegawai();
    },
    scrollToItemPegawai() {
      this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
    },

    sorting(value) {
      if (value == 0) {
        function compare(a, b) {
          if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
            return -1;
          }
          if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 1) {
        function compare(a, b) {
          if (a.keterangan.toLowerCase() < b.keterangan.toLowerCase()) {
            return -1;
          }
          if (a.keterangan.toLowerCase() > b.keterangan.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 2) {
        function compare(a, b) {
          if (a.tanggalMulai.toLowerCase() < b.tanggalMulai.toLowerCase()) {
            return -1;
          }
          if (a.tanggalMulai.toLowerCase() > b.tanggalMulai.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 3) {
        function compare(a, b) {
          if (a.tanggalSelesai.toLowerCase() < b.tanggalSelesai.toLowerCase()) {
            return -1;
          }
          if (a.tanggalSelesai.toLowerCase() > b.tanggalSelesai.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 4) {
        function compare(a, b) {
          if (a.lamaCuti.toLowerCase() < b.lamaCuti.toLowerCase()) {
            return -1;
          }
          if (a.lamaCuti.toLowerCase() > b.lamaCuti.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 5) {
        function compare(a, b) {
          if (a.namaAtasan.toLowerCase() < b.namaAtasan.toLowerCase()) {
            return -1;
          }
          if (a.namaAtasan.toLowerCase() > b.namaAtasan.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      } else if (value == 6) {
        function compare(a, b) {
          if (a.status.toLowerCase() < b.status.toLowerCase()) {
            return -1;
          }
          if (a.status.toLowerCase() > b.status.toLowerCase()) {
            return 1;
          }
          return 0;
        }
        return this.datas.sort(compare);
      }
    },
    getDataRekap() {
      let payload = {};
      DataApi.post('cuti/summary/lihat', payload).then((res) => {
        let response = res.data;
        if (response.success == true) {
          let temp = response.data[0];
          if (temp.cutiHariIni != 'null') {
            this.totalCuti = temp.cutiHariIni;
          } else {
            this.totalCuti = 0;
          }
          if (temp.rencanaCuti != 'null') {
            this.totalRencana = temp.rencanaCuti;
          } else {
            this.totalRencana = 0;
          }
          if (temp.cutiDadakan != 'null') {
            this.totalTakTerencana = temp.cutiDadakan;
          } else {
            this.totalTakTerencana = 0;
          }
          if (temp.waitingApproval != 'null') {
            this.totalMenunggu = temp.waitingApproval;
          } else {
            this.totalMenunggu = 0;
          }
        }
      });
    },
    getDownload() {
      if (this.datas.length != 0) {
        let limit = this.totalRow;
        let namaAtasanPegawai = '';
        let namaNik = this.queryPegawai.split(' - ')[1];
        let page = 1;
        let tanggalMulai = this.dateStart;
        let tanggalSelesai = this.dateEnd;
        let tipeCuti = this.selectedType.value;
        let lvl = '';
        let status = this.selectedStatus.value;
        let tipePegawai = this.tipePegawai.value;

        let payload = {
          limit: limit,
          namaAtasanPegawai: namaAtasanPegawai,
          pageIn: page,
          status: status,
          namaNik: namaNik,
          tanggalMulai: tanggalMulai,
          tanggalSelesai: tanggalSelesai,
          tipeCuti: tipeCuti,
          lvl: lvl,
          tipePegawai: tipePegawai,
        };
        DataApi.post('/export/cuti/lihat', payload, { responseType: 'blob' }).then((res) => {
          let response = res.data;
          // let fileName = res.headers["content-disposition"].split("filename=")[1];
          const url = URL.createObjectURL(
            new Blob([response], {
              type: 'application/vnd.ms-excel',
            })
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Izin Cuti');
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    getData() {
      if (this.flagSearch == true) {
        this.page = 1;
      }
      this.$store.state.loadingScreen = true;
      let limit = this.size;
      let namaAtasanPegawai = '';
      let namaNik = this.queryPegawai.split(' - ')[1];
      let page = this.page;
      let tanggalMulai = this.dateStart;
      let tanggalSelesai = this.dateEnd;
      let tipeCuti = this.selectedType.value;
      let lvl = '';
      let status = this.selectedStatus.value;
      let tipePegawai = this.tipePegawai.value;

      let payload = {
        limit: limit,
        namaAtasanPegawai: namaAtasanPegawai,
        pageIn: page,
        status: status,
        namaNik: namaNik,
        tanggalMulai: tanggalMulai,
        tanggalSelesai: tanggalSelesai,
        tipeCuti: tipeCuti,
        lvl: lvl,
        tipePegawai: tipePegawai,
      };
      DataApi.post('cuti/lihat', payload).then((res) => {
        let response = res.data;
        if (response.success == true) {
          this.datas = response.data.data;
          this.totalRow = response.data.totalRow;
          this.firstPage = (this.page - 1) * this.size + 1;
          this.lastPage = (this.page - 1) * this.size + this.datas.length;
          this.totalPage = Math.floor(this.totalRow / this.size);
          let modAr = this.totalRow % this.size;
          if (modAr != 0) {
            this.totalPage = this.totalPage + 1;
          } else {
            //
          }
        } else {
          this.datas = [];
          this.totalRow = 0;
          this.firstPage = 0;
          this.lastPage = 0;
          this.totalPage = 1;
          this.errorMessage = response.message;
        }
        this.flagSearch = false;
        this.$store.state.loadingScreen = false;
      });
    },
    getDataType() {
      let payload = {
        kelompok: '',
        keterangan: '',
        kode: '',
        limit: 999,
        pageIn: 1,
      };
      DataApi.post('absensi/backoffice/tidak_masuk_lihat', payload).then((res) => {
        this.dataType = [];
        let response = res.data.data.data;
        var i = 0;
        for (i = 0; i < response.length; i++) {
          let pushs = {
            value: response[i].kode,
            text: response[i].keterangan,
          };
          this.dataType.push(pushs);
        }
      });
    },
    getDataStatus() {
      this.dataStatus = [
        {
          text: 'Waiting',
          value: 'W',
        },
        {
          text: 'Disetujui',
          value: 'A',
        },
        {
          text: 'Ditolak',
          value: 'R',
        },
      ];
    },
    findData() {
      this.getData();
    },
    movePage(direction) {
      if (direction == 'prev') {
        this.page = this.page - 1;
      } else {
        this.page = this.page + 1;
      }
      this.getData();
    },
    validatePage(page) {
      if (page > this.totalPage) {
        this.page = this.totalPage;
      }
    },
    reload() {
      this.queryPegawai = '';
      this.dateStart = '';
      this.dateEnd = '';
      this.selectedType.value = '';
      this.selectedType.text = '';
      this.selectedStatus.value = '';
      this.selectedStatus.text = '';
      this.tipePegawai.value = '';
      this.tipePegawai.text = '';
      this.getDataTipePegawai();
      this.getDataStatus();
      this.getDataType();
      this.flagSearch = true;
      this.getData();
      if (this.classReload == 'reloadOff') {
        this.classReload = 'reloadOn';
      } else {
        this.classReload = 'reloadOff';
      }
    },
    getDataTipePegawai() {
      let payload = {
        keterangan: '',
        limit: 9999,
        pageIn: 1,
      };
      DataApi.post('pegawai/status/lihat', payload).then((res) => {
        this.dataTipePegawai = [{ value: '', text: 'Semua' }];
        let response = res.data;
        let tempData = response.data.data;
        var i = 0;
        for (i = 0; i < tempData.length; i++) {
          let onPush = {
            value: tempData[i].kode,
            text: tempData[i].keterangan,
          };
          this.dataTipePegawai.push(onPush);
        }
      });
    },
  },
  computed: {
    matchesPegawai() {
      if (this.queryPegawai == '') {
        return [];
      }
      return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()));
    },
    matchesAddPegawai() {
      if (this.queryAddPegawai == '') {
        return [];
      }
      return this.dataAddPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryAddPegawai.toLowerCase()));
    },
  },
  mounted() {
    this.errorMessage = 'Find Your Data';
    this.getDataAdmin();
    this.getDataAddTipe();
    this.getDataAddBukti();
    this.getDataTipePegawai();
  },
};
</script>

<style scoped>
.autocomplete {
  width: 100%;
  position: relative;
}
.input {
  cursor: text;
}
.close {
  position: absolute;
  right: 8px;
  top: 10px;
  background: none;
  border: none;
  font-size: 14px;
  color: lightgrey;
  cursor: pointer;
}
.placeholder {
  position: absolute;
  top: 7px;
  left: 16px;
  font-size: 14px;
  color: #d0d0d0;
}
.popovers {
  text-align: center;
  width: 100% !important;
  min-height: 50px;
  border: 1px solid #d8dbe0;
  position: absolute;
  top: 35px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 3px;
  text-align: center;
  z-index: 3;
}
.popovers input {
  right: 8px;
  left: 8px;
  width: 100%;
}
.options {
  max-height: 200px;
  overflow-y: auto;
  margin-top: 5px;
}
.options ul {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
}
.options ul li {
  border-bottom: 1px solid lightgrey;
  padding: 10px;
  cursor: pointer;
  background: white;
}
.options ul li:first-child {
  border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
  background: whitesmoke;
  color: rgba(16, 16, 16, 1);
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(16, 16, 16, 1);
}
.card-subtitle {
  font-size: 12px;
  color: rgba(154, 154, 154, 1);
}
.card-emblem {
  float: right;
  background-color: rgba(48, 107, 221, 0.05);
  text-align: center;
  line-height: 32px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
  .inputs-form {
    float: left;
    width: 40%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
  .inputs-form {
    float: left;
    width: 39%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
  .inputs-form {
    float: left;
    width: 38%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
  .inputs-form {
    float: left;
    width: 37%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
  .inputs-form {
    float: left;
    width: 36%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
@media screen and (min-width: 1359px) {
  .inputs-form {
    float: left;
    width: 41%;
    margin-right: 12px;
    background-color: rgba(249, 250, 252, 1);
  }
}
.reloadOn {
  float: left;
  cursor: pointer;
  transform: rotate(-180deg);
  transition: 300ms linear all;
}
.reloadOff {
  float: left;
  cursor: pointer;
  transform: rotate(180deg);
  transition: 300ms linear all;
}
div.search-area {
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px !important;
  background-color: white;
  z-index: 1;
}
div.sticky1 {
  position: -webkit-sticky;
  position: sticky;
  top: 54px;
  padding-top: 12px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 12px !important;
  background-color: white;
  z-index: 1;
}
input {
  background-color: rgba(249, 250, 252, 1);
}
::v-deep .ui.search.dropdown > .text {
  overflow: hidden !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.btn-add {
  border-radius: 4px;
  width: 100%;
  float: right;
  margin-left: 4px;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}
.btn-add:hover {
  border-radius: 4px;
  width: 100%;
  margin-left: 4px;
  float: right;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}
.btn-search {
  border-radius: 4px;
  float: right;
  width: 100%;
  margin-left: 4px;
  background-color: rgba(48, 107, 221, 1);
  color: white;
}
.btn-search:hover {
  border-radius: 4px;
  float: right;
  width: 100%;
  margin-left: 4px;
  background-color: rgba(48, 107, 255, 1);
  color: white;
}
::v-deep .modal-header {
  border-bottom: none !important;
}
.headers-modal {
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(16, 16, 16, 1);
}
.btn-cancel {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: white;
  color: rgba(16, 16, 16, 1);
  font-weight: 500;
  font-size: 14px;
}
.btn-cancel:hover {
  border-radius: 4px;
  width: 200px;
  float: left;
  border: 1px solid rgba(48, 107, 221, 1);
  background-color: rgba(48, 107, 221, 1);
  color: white;
}
.cards-image {
  position: absolute;
  text-align: center;
  font-size: 27px;
  color: rgba(96, 96, 96, 1);
  line-height: 50px;
  border: 1px dotted rgba(221, 221, 221, 1);
  width: 56px !important;
  background-color: rgba(250, 250, 250, 1);
  height: 56px !important;
}
</style>
